export default __webpack_public_path__ + "static/media/OpenSans-ExtraBold.1e2f7dd9.woff";